module.exports = __webpack_public_path__ + "img/aialgorithm-black.81991458.png";